/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiImportExternalErpItemsRequest, ApiService } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ExternalErpServicesController.
 */
export class ExternalErpServicesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /external_erp/services:query
     */
    public getImportableServices(listRequest: ListRequest): Promise<Result<ListInfo<ApiService>>> {
        return this.http.post<Result<ListInfo<ApiService>>, ListRequest>('/external_erp/services:query', listRequest);
    }

    /**
     * Calls POST /external_erp/services:import
     */
    public importServices(request: ApiImportExternalErpItemsRequest): Promise<Result<ApiService[]>> {
        return this.http.post<Result<ApiService[]>, ApiImportExternalErpItemsRequest>('/external_erp/services:import', request);
    }
}
